module.exports = __webpack_public_path__ + "static/nike-img-3-4a1f1bb18d9c144351486293525850fc.jpg";